<template>
  <div class="d-flex justify-content-between">
    <div>{{ action }}</div>
    <div class="align-self-center items ml-1">
      <span class="muted-badge" v-for="(key, index) in keyCombination" :key="index">{{
        keyLabel[key] || prettifyKey(key)[0]
      }}</span>
    </div>
  </div>
</template>

<script>
/**
 * This component shows action and corresponding keyboard key
 */

import { ctrlKeyLabel } from '@/constants/keyCodes'
import prettifyKey from '@/utils/prettifyKey'

export default {
  name: 'ActionKey',
  props: {
    action: String,
    keyCombination: Array
  },
  data() {
    return {
      keyLabel: {
        Ctrl: ctrlKeyLabel
      }
    }
  },
  methods: {
    prettifyKey
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/components/badge';
.items .muted-badge:not(:last-child) {
  margin-right: 2px;
}
</style>
